import {
  MessagingListQueryOptions,
  MessagingListRulesQuery,
} from "./MessagingListRules";
import { Badge, Box, Button, Flex, Text } from "@radix-ui/themes";
import FontAwesome from "../../utilities/FontAwesome";
import { useState } from "react";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import WatsonApi from "../../../backends/WatsonApi";

function RecipientDisplayContainer(props) {
  return (
    <Box py={"1"}>
      <Flex justify={"between"} align={"center"}>
        {props.children}
      </Flex>
    </Box>
  );
}

export function MessagingListRuleDisplay(props: {
  rule: MessagingListRulesQuery;
  deleteRule: () => void;
}) {
  const [total, setTotal] = useState(null);

  useAsyncEffect(async () => {
    const client = await WatsonApi();
    const result =
      await client.apis.organizations.organizations_messaging_lists_preview_dynamic_members(
        {
          organization_pk:
            props.rule[MessagingListQueryOptions.Organization]?.filter,
          page_size: 1, // 0 triggers return all, but all we're after is the total
          data: {
            rules: [props.rule],
          },
        },
      );
    const parsed = JSON.parse(result.data);
    setTotal(parsed.meta.total);
  }, []);

  return (
    <RecipientDisplayContainer>
      <Flex align={"center"} gapX={"2"}>
        <Badge color={"gray"} size={"3"}>
          {props.rule[MessagingListQueryOptions.Group]?.value}
        </Badge>
        {props.rule[MessagingListQueryOptions.Grade] && (
          <>
            <Badge color={"green"}>OF</Badge>
            <Badge color={"gray"} size={"3"}>
              {props.rule[MessagingListQueryOptions.Grade]?.value}
            </Badge>
          </>
        )}
        <Badge color={"green"}>AT</Badge>
        <Badge color={"gray"} size={"3"}>
          {props.rule[MessagingListQueryOptions.Organization]?.value}
        </Badge>
        {total !== null && `(${total} recipients)`}
      </Flex>
      <Button color={"red"} size={"1"} onClick={props.deleteRule}>
        <FontAwesome name={"fa-times"} prefix={"fas"} />
      </Button>
    </RecipientDisplayContainer>
  );
}

export function MessagingListRecipientDisplay(props: {
  recipient: IUser;
  deleteRecipient: () => void;
}) {
  return (
    <RecipientDisplayContainer>
      <Text>
        {props.recipient.fname} {props.recipient.lname}
      </Text>
      <Button color={"red"} size={"1"} onClick={props.deleteRecipient}>
        <FontAwesome name={"fa-times"} prefix={"fas"} />
      </Button>
    </RecipientDisplayContainer>
  );
}
